module.exports = __webpack_public_path__ + "static/media/jack_summit_intro_small_12.c37c7fc6.jpg";